import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import clsx from 'clsx';
import { TypedMemo } from '../../../common/types';
import type { ContactFilters } from '../hooks/useContacts';
import { contactsMessages as messages } from './contactsMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for Outreach; each part uses its own slice of it */
import shared from '../Outreach.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface ContactsToolbarProps {
  filters: ContactFilters;
  onChange: (patch: Partial<ContactFilters>) => void;
  total: number;
}

/** The search and the tag filter of Contacts (design outreach q1 filter bar). */
const ContactsToolbarComponent: React.FC<ContactsToolbarProps> = ({ filters, onChange, total }) => {
  const intl = useIntl();
  const [q, setQ] = useState(filters.q);
  useEffect(() => {
    const timer = setTimeout(() => {
      if (q !== filters.q) {
        onChange({ q });
      }
    }, 300);
    return () => clearTimeout(timer);
  }, [filters.q, onChange, q]);

  return (
    <div className={shared.row}>
      <input
        className={clsx(shared.input, 'w-auto')}
        value={q}
        placeholder={intl.formatMessage(messages.search)}
        aria-label={intl.formatMessage(messages.search)}
        onChange={(event) => setQ(event.target.value)}
      />
      <input
        className={clsx(shared.input, 'w-auto')}
        size={12}
        defaultValue={filters.tag ?? ''}
        placeholder={intl.formatMessage(messages.tagFilter)}
        aria-label={intl.formatMessage(messages.tagFilter)}
        onBlur={(event) => onChange({ tag: event.target.value.trim() === '' ? null : event.target.value.trim() })}
      />
      <span className={shared.grow} />
      <span className={shared.small}>{intl.formatMessage(messages.count, { count: total })}</span>
    </div>
  );
};

export const ContactsToolbar = TypedMemo(ContactsToolbarComponent);
